import { connect } from 'dva';
import { routerRedux } from 'dva/router';
import { CompanySwitch } from './CompanySwitch';

export const mapStateToProps = (state, ownProps) => {
  const {
    authentication: { organizations, switchModal }
  } = state;
  return {
    organizations,
    switchModal
  };
};

export const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    redirect(pathname, search) {
      dispatch(routerRedux.push({ pathname, search: search }));
    },
    closeModal() {
      dispatch({
        type: 'authentication/save',
        payload: { switchModal: false }
      });
    },
    switchOrganizations(data) {
      dispatch({ type: 'authentication/switchOrganizations', payload: data });
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CompanySwitch);
